import { motion } from "framer-motion";
import { Reveal, Eyebrow } from "@/lib/motion";
import { SERVICES } from "@/data";

const TONES = {
  sage: "bg-brand-sage text-brand-ink border-brand-teal",
  peach: "bg-brand-peach text-brand-ink border-brand-apricot",
  apricot: "bg-brand-apricot text-brand-ink border-brand-teal",
  cream: "bg-brand-cream text-brand-ink border-brand-peach",
};

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="max-w-7xl mx-auto px-6 md:px-12 py-8 md:py-12">
      <div className="grid md:grid-cols-12 gap-6 items-end mb-14 md:mb-20">
        <div className="md:col-span-7">
          <Eyebrow>What we build</Eyebrow>
          <h2 className="mt-5 font-display font-normal text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.02]">
            Agents that earn their keep from day one.
          </h2>
        </div>
        <p className="md:col-span-4 md:col-start-9 text-brand-ink/70 text-lg leading-relaxed">
          Each one is trained on your business, wired into your tools and tuned until it feels like part of the team.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-6 gap-6 auto-rows-[minmax(200px,auto)]">
        {SERVICES.map((s, i) => (
          <Reveal key={s.no} delay={i * 0.08} className={s.span}>
            <motion.div
              whileHover={{ y: -6 }}
              transition={{ duration: 0.3 }}
              className={`h-full rounded-3xl border p-8 flex flex-col justify-between ${TONES[s.tone]}`}
            >
              <span className="font-mono text-xs tracking-[0.2em] opacity-70">AGENT // {s.no}</span>
              <div>
                <h3 className="font-display text-2xl md:text-3xl mb-3">{s.title}</h3>
                <p className="text-brand-ink/75 leading-relaxed">{s.desc}</p>
              </div>
            </motion.div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
